import React from "react";
import { Flame, Zap, Clock, AlertCircle } from "lucide-react";
import {
  CompactKpiRibbon,
  type CompactKpiItem,
} from "@/components/shared/CompactKpiRibbon";

export type UrgencyFilterType = "urgent" | "high" | "approaching" | "overdue";

export interface ProductionOrderUrgencyCounts {
  urgent: number;
  high: number;
  approaching: number;
  overdue: number;
}

interface Props {
  counts: ProductionOrderUrgencyCounts;
  activeFilter: UrgencyFilterType | null;
  onSelectFilter: (filter: UrgencyFilterType | null) => void;
  isLoading?: boolean;
  className?: string;
}

export const ProductionOrderKpiCards: React.FC<Props> = ({
  counts,
  activeFilter,
  onSelectFilter,
  isLoading = false,
  className,
}) => {
  const items: CompactKpiItem<UrgencyFilterType>[] = [
    {
      key: "urgent",
      label: "LSX Hỏa Tốc",
      count: counts.urgent,
      icon: Flame,
      variant: "rose",
      animate: counts.urgent > 0,
      testId: "po-kpi-urgent",
      tooltip: "Ưu tiên số 1 toàn ca",
    },
    {
      key: "high",
      label: "LSX Gấp",
      count: counts.high,
      icon: Zap,
      variant: "amber",
      testId: "po-kpi-high",
      tooltip: "Ưu tiên cao",
    },
    {
      key: "approaching",
      label: "Cận Hạn Giao",
      count: counts.approaching,
      icon: Clock,
      variant: "amber",
      testId: "po-kpi-approaching",
      tooltip: "< 48 giờ",
    },
    {
      key: "overdue",
      label: "Quá Hạn",
      count: counts.overdue,
      icon: AlertCircle,
      variant: "rose",
      testId: "po-kpi-overdue",
      tooltip: "Trễ tiến độ",
    },
  ];

  return (
    <CompactKpiRibbon
      items={items}
      activeKey={activeFilter}
      onSelect={onSelectFilter}
      isLoading={isLoading}
      className={className}
    />
  );
};
